module.exports = __webpack_public_path__ + "img/approve-list10.ace33186.png";